import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const EditStaff = () => {
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const navigate = useNavigate();
    const { id } = useParams();

    const [data, setData] = useState({
        name: '',
        contact: '',
        date: '',
        amount: '',
        salarytype: '',
        role: '',
    });

    useEffect(() => {
        if (!id) return;
        const fetchStaff = async () => {
            try {
                const { data: res } = await axios.get(`${base_url}/api/v1/staff/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const { amount, joining_date, mob_no, name, salary_role, salary_type } = res.data;
                setData({
                    name: name || '',
                    contact: mob_no || '',
                    date: joining_date ? new Date(joining_date).toISOString().split('T')[0] : '',
                    amount: amount || '',
                    salarytype: salary_type || '',
                    role: salary_role || '',
                });
            } catch (error) {
                toast.error('Failed to fetch staff data.');
            }
        };
        fetchStaff();
    }, [id]);

    const formHandler = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const btnHandler = async (e) => {
        e.preventDefault();
        const { name, contact, date, amount, salarytype, role } = data;

        if (!name || !contact || !date || !amount || !salarytype || !role) {
            toast.error('Please fill all fields.');
            return;
        }

        try {
            const response = await axios.put(`${base_url}/api/v1/staff/staff-update/${id}`, {
                id, name, contact, date, amount, salarytype, role
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            if (response.status === 200) {
                toast.success('Staff updated successfully.');
                navigate('/dashboard/manage-staff');
            } else {
                toast.error('Failed to update staff.');
            }
        } catch (err) {
            console.error('Error updating staff:', err);
            toast.error('An error occurred while updating staff.');
        }
    };

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header text-center">
                                <h4>Update Staff</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={btnHandler} className="form-horizontal">
                                    <div className="form-group">
                                        <label>Full Name <span className="text-danger">*</span></label>
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your name"
                                            value={data.name}
                                            onChange={formHandler}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Contact Number <span className="text-danger">*</span></label>
                                        <input
                                            name="contact"
                                            type="tel"
                                            maxLength={10}
                                            className="form-control"
                                            placeholder="Contact Number"
                                            value={data.contact}
                                            onChange={formHandler}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Role <span className="text-danger">*</span></label>
                                        <select
                                            name="role"
                                            className="form-select"
                                            value={data.role}
                                            onChange={formHandler}
                                        >
                                            <option value="">Select Role</option>
                                            <option value="employee">Employee</option>
                                            <option value="manager">Manager</option>
                                            <option value="Labor">Labor</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Salary Calculation Date <span className="text-danger">*</span></label>
                                        <input
                                            name="date"
                                            type="date"
                                            className="form-control"
                                            value={data.date}
                                            onChange={formHandler}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Salary Type <span className="text-danger">*</span></label>
                                        <div className="d-flex gap-3">
                                            {['monthly', 'daily', 'hourly'].map((type) => (
                                                <div className="form-check form-check-inline" key={type}>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id={type}
                                                        name="salarytype"
                                                        value={type}
                                                        checked={data.salarytype === type}
                                                        onChange={formHandler}
                                                    />
                                                    <label className="form-check-label" htmlFor={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Amount <span className="text-danger">*</span></label>
                                        <input
                                            name="amount"
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Amount.."
                                            value={data.amount}
                                            onChange={formHandler}
                                        />
                                    </div>

                                    <button type="submit" className="btn text-white mt-3" style={{ backgroundColor: '#085f9a' }}>
                                        Update
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditStaff;